
var target = document.querySelector('sticky-add-to-cart [ref="quantityNumber"]')


if(target){
  
const observer = new MutationObserver( (mutations) => {
  var updateNum = target.innerHTML;
  
  var inputs = document.querySelectorAll('.product_section input[ref="quantityInput"]');
  inputs.forEach(el => {
    el.value = updateNum;

    var btn = el.closest('quantity-selector-component')
    if(el.value > 1){
      btn.querySelectorAll('button').forEach(btn => {
        btn.removeAttribute('disabled')
      })
    }
  });
});

observer.observe(target, {
  childList: true,
  characterData: true,
  subtree: true
});

} else{
  console.log('target is not found');
  
}










const addToCartSection = document.querySelector('.product-form-buttons');
const stickyBtn = document.querySelector('.sticky-add-to-cart');

if (addToCartSection && stickyBtn) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyBtn.classList.add('remove');
        } else {
          stickyBtn.classList.remove('remove');
        }
      });
    },
    {
      threshold: 0, // Trigger when 10% is visible
      rootMargin: '-80px'
    }
  );

  observer.observe(addToCartSection);
}




// product media sticky 

var header = document.querySelector('header-component').offsetHeight;

  if (window.innerWidth > 768) {
    document.querySelector('.product_section .product_media').style.top = header + 'px';
  }

